import { useAdAccountStore } from 'stores';
import type { CreateSeedAudienceAdAccountSelectProps } from 'types/audiences';
import CreateSeedAudienceAdAccountSelectView from './CreateSeedAudiencesAdAccountSelect.View';

const CreateSeedAudienceAdAccountSelect = (props: CreateSeedAudienceAdAccountSelectProps) => {
  const { galaxies } = props;
  const { metaAdAccountsList } = useAdAccountStore();

  const adAccountIds = [...new Set(galaxies.flatMap(galaxy => galaxy.allowedAdAccountIds))];

  const formattedAdAccounts = metaAdAccountsList
    .filter(account => adAccountIds.includes(account.adAccountId))
    .map(account => ({
      value: account.adAccountId,
      label: account.name
    }));

  return <CreateSeedAudienceAdAccountSelectView formattedAdAccounts={formattedAdAccounts} />;
};

export default CreateSeedAudienceAdAccountSelect;
